import { isDevMode } from '@angular/core';
import type { Routes } from '@angular/router';
import { BusinessModule } from '../../auth/common/enums/business/business-module';
import { moduleGuard } from '../../auth/common/guards/module.guard';
import { BASES_ROUTES } from './bases/bases.routes';
import { BUSINESS_ROUTES } from './business/business.routes';
import { CONTRACTORS_ROUTES } from './contractors/contractors.routes';
import { DICTIONARIES_ROUTES } from './dictionaries/dictionaries.routes';
import { DOCUMENTS_ROUTES } from './documents/documents.routes';
import { EMPLOYEES_ROUTES } from './employees/employees.routes';
import { ENGINE_CONFIG_ROUTES } from './engine-config/engine-config.routes';
import { FUEL_POLICY_ROUTES } from './fuel-policy/fuel-policy.routes';
import { INTEGRATIONS_ROUTES } from './integrations/integrations.routes';
import { POINTS_OF_INTEREST_ROUTES } from './points-of-interest/points-of-interest.routes';
import { ROUTE_COSTS_AND_PREFERENCES_ROUTES } from './route-costs-and-preferences/route-costs-and-preferences.routes';

export const MANAGEMENT_PANEL_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    redirectTo: 'employees',
  },
  {
    path: 'employees',
    children: EMPLOYEES_ROUTES,
  },
  {
    path: 'contractors',
    children: CONTRACTORS_ROUTES,
  },
  {
    path: 'points-of-interest',
    children: POINTS_OF_INTEREST_ROUTES,
  },
  {
    path: 'bases',
    canActivate: [moduleGuard(BusinessModule.BASES)],
    children: BASES_ROUTES,
  },
  ...(isDevMode()
    ? [
        {
          path: 'fuel-policy',
          canActivate: [moduleGuard(BusinessModule.FUEL_POLICY)],
          children: FUEL_POLICY_ROUTES,
        },
        {
          path: 'route-costs-and-preferences',
          canActivate: [
            moduleGuard(BusinessModule.ROUTE_COSTS_AND_PREFERENCES),
          ],
          children: ROUTE_COSTS_AND_PREFERENCES_ROUTES,
        },
      ]
    : []),
  {
    path: 'engine-config',
    canActivate: [moduleGuard(BusinessModule.ENGINE_CONFIG)],
    children: ENGINE_CONFIG_ROUTES,
  },
  {
    path: 'business',
    children: BUSINESS_ROUTES,
  },
  {
    path: 'dictionaries',
    children: DICTIONARIES_ROUTES,
  },
  ...(isDevMode()
    ? [
        {
          path: 'documents',
          children: DOCUMENTS_ROUTES,
        },
      ]
    : []),
  {
    path: 'integrations',
    canActivate: [moduleGuard(BusinessModule.INTEGRATIONS)],
    children: INTEGRATIONS_ROUTES,
  },
] as const;
